import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Select, Button, Row, Tag, Table, Radio } from 'antd';

const OrtopticaVisionBinocular = () => {
  return (
    <div>

      <Formik
        initialValues={[]}
        onSubmit={() => { }}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className="space-y-6 p-6 bg-white shadow-lg rounded-lg">
            {/* Sección Paciente */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Pacientes</label>
              <Select
                showSearch
                placeholder="Seleccione el paciente"
                options={[]}
                className="w-full"
                onChange={(value) => { }}
              // filterOption={(input, option) =>
              //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              // }
              />
              <ErrorMessage name="paciente" component="div" className="text-red-500 text-sm" />
            </div>

            {/* Sección Información Básica */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sucursal</label>
                <Field as="select" name="sucursal" className="w-full p-2 border rounded">
                  <option value="">Seleccionar sucursal</option>
                  {[
                    { id_sucursal: 1, nombre: "sucursal" }
                  ].map((sucursal) => (
                    <option key={sucursal.id_sucursal} value={sucursal.id_sucursal}>
                      {sucursal.nombre}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="sucursal" component="div" className="text-red-500 text-sm" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Edad</label>
                <Field
                  name="edad"
                  className="w-full p-2 border rounded bg-gray-100"
                  readOnly
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de atención</label>
                <Field
                  name="fecha_atencion"
                  type="date"
                  className="w-full p-2 border rounded"
                  required
                />
              </div>
            </div>

            {/* Motivo de Consulta */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Motivo de Consulta</label>
              <Field
                as="textarea"
                name="m_c"
                className="w-full p-2 border rounded min-h-[100px]"
                maxLength={10000}
              />
            </div>

            {/* Antecedentes */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Antecedentes Oculares</label>
                <Field name="a_o" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Antecedentes Personales</label>
                <Field name="a_p" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Antecedentes Familiares</label>
                <Field name="a_f" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* Medicamentos y Tratamientos */}
            <div className="grid grid-cols-1 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Medicamentos</label>
                <Field name="medicamentos" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tratamientos anteriores</label>
                <Field name="tratamientos" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* AGUDEZA VISUAL */}
            <h5 className="text-lg font-bold mb-4">AGUDEZA VISUAL</h5>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              {/* Tabla AV/SC */}
              <div className="overflow-x-auto">
                <table className="min-w-full border">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border px-4 py-2 text-center">AV/SC</th>
                      <th className="border px-4 py-2">OD</th>
                      <th className="border px-4 py-2">OI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {['vl', 'vp', 'ph'].map((tipo) => (
                      <tr key={tipo}>
                        <td className="border px-4 py-2 text-center">{tipo.toUpperCase()}</td>
                        <td className="border px-4 py-2">
                          <Field name={`av_sc.av_sc_od_${tipo}`} className="w-full p-1 border rounded" />
                        </td>
                        <td className="border px-4 py-2">
                          <Field name={`av_sc.av_sc_oi_${tipo}`} className="w-full p-1 border rounded" />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Tabla AV/CC */}
              <div className="overflow-x-auto">
                <table className="min-w-full border">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border px-4 py-2 text-center">AV/CC</th>
                      <th className="border px-4 py-2">OD</th>
                      <th className="border px-4 py-2">OI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {['vl', 'vp', 'ph'].map((tipo) => (
                      <tr key={tipo}>
                        <td className="border px-4 py-2 text-center">{tipo.toUpperCase()}</td>
                        <td className="border px-4 py-2">
                          <Field name={`av_cc.av_cc_od_${tipo}`} className="w-full p-1 border rounded" />
                        </td>
                        <td className="border px-4 py-2">
                          <Field name={`av_cc.av_cc_oi_${tipo}`} className="w-full p-1 border rounded" />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Dominancia */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <h6 className="font-semibold mb-2">OJO DOMINANTE</h6>
                <Radio.Group name="ojo_dominante" className="flex gap-4">
                  <Radio value="IZQUIERDO">IZQUIERDO</Radio>
                  <Radio value="DERECHO">DERECHO</Radio>
                </Radio.Group>
              </div>
              <div>
                <h6 className="font-semibold mb-2">MANO DOMINANTE</h6>
                <Radio.Group name="mano_dominante" className="flex gap-4">
                  <Radio value="IZQUIERDA">IZQUIERDA</Radio>
                  <Radio value="DERECHO">DERECHA</Radio>
                </Radio.Group>
              </div>
            </div>

            {/* LENSOMETRIA */}
            <h5 className="text-lg font-bold mb-4">LENSOMETRIA</h5>
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-center">RX EN USO</th>
                    <th className="border px-4 py-2">ESFERA</th>
                    <th className="border px-4 py-2">CILINDRO</th>
                    <th className="border px-4 py-2">EJE</th>
                    <th className="border px-4 py-2">P/BASE △</th>
                    <th className="border px-4 py-2">ADD</th>
                  </tr>
                </thead>
                <tbody>
                  {['od', 'oi'].map((ojo) => (
                    <tr key={ojo}>
                      <td className="border px-4 py-2 text-center">{ojo.toUpperCase()}</td>
                      <td className="border px-4 py-2">
                        <Field name={`lensometria.esfera_${ojo}`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`lensometria.cilindro_${ojo}`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`lensometria.eje_${ojo}`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`lensometria.p_base_${ojo}`} className="w-full p-1 border rounded" placeholder="△" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`lensometria.add_${ojo}`} className="w-full p-1 border rounded" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Lentes */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de lentes</label>
                <Field name="lensometria_extra.len_tipo_lentes" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Filtros</label>
                <Field name="lensometria_extra.len_filtros" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tiempo</label>
                <Field name="lensometria_extra.len_tiempo" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Aro</label>
                <Field name="lensometria_extra.len_tipo_arco" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* Segmento Anterior y Polo Posterior */}
            <div className="mb-6">
              <h5 className="text-lg font-bold mb-2">Segmento Anterior / Polo Posterior</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">OD</label>
                  <div className="grid grid-cols-2 gap-2">
                    <Field name="sa_pp.sa_od" placeholder="Segmento Anterior" className="w-full p-2 border rounded" />
                    <Field name="sa_pp.pp_od" placeholder="Polo Posterior" className="w-full p-2 border rounded" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">OI</label>
                  <div className="grid grid-cols-2 gap-2">
                    <Field name="sa_pp.sa_oi" placeholder="Segmento Anterior" className="w-full p-2 border rounded" />
                    <Field name="sa_pp.pp_oi" placeholder="Polo Posterior" className="w-full p-2 border rounded" />
                  </div>
                </div>
              </div>
            </div>

            {/* VISUSCOPIA */}
            <h6 className="font-semibold mb-2">VISUSCOPIA:</h6>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">OD</label>
                <Field name="visuscopia.viscopia_od" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">OI</label>
                <Field name="visuscopia.viscopia_oi" className="w-full p-2 border rounded" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Hirschberg</label>
                <Field name="visuscopia.hirschberg" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Krismsky</label>
                <Field name="visuscopia.krismsky" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* VERSIONES */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">VERSIONES:</label>
              <Field
                as="textarea"
                name="plan_versiones"
                className="w-full p-2 border rounded min-h-[100px]"
              />
            </div>

            {/* COVER TEST */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">COVER TEST: VL:</label>
                <Field name="visuscopia.ct_vl" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">VP</label>
                <Field name="visuscopia.ct_vp" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MADDOX:</label>
                <Field name="visuscopia.maddox" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* Seguimiento Visual */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Seguimiento Visual(AO):</label>
                <Field name="visuscopia_extra.seguimiento_ao" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sacádicos(AO):</label>
                <Field name="visuscopia_extra.sacadicos_ao" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* PPC */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">PPC: OR</label>
                <Field name="visuscopia_extra.ppc_or" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">L:</label>
                <Field name="visuscopia_extra.ppc_l" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">FR:</label>
                <Field name="visuscopia_extra.ppc_fr" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Posicion compensatoria:</label>
                <Field name="visuscopia_extra.ppc_posicion" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* Tests */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">TEST DE BIELSCHOWSKY</label>
                <Field name="visuscopia_extra.helshoswky" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">VON GRAEFE</label>
                <Field name="visuscopia_extra.von_graefe" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* PRUEBAS SENSORIALES */}
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-center">PRUEBAS SENSORIALES</th>
                    <th className="border px-4 py-2 text-center">VISION LEJANA</th>
                    <th className="border px-4 py-2 text-center">VISION PROXIMA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2 text-center">Luces de Worth</td>
                    <td className="border px-4 py-2">
                      <Field name="pruebas.vl_luces" className="w-full p-1 border rounded" />
                    </td>
                    <td className="border px-4 py-2">
                      <Field name="pruebas.vp_luces" className="w-full p-1 border rounded" />
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 text-center">Bagolinni</td>
                    <td className="border px-4 py-2">
                      <Field name="pruebas.vl_bg" className="w-full p-1 border rounded" />
                    </td>
                    <td className="border px-4 py-2">
                      <Field name="pruebas.vp_bg" className="w-full p-1 border rounded" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Estereopsis */}
            <div className="mb-6">
              <h5 className="text-lg font-bold text-center mb-2">Estereopsis</h5>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Randot:</label>
                  <Field name="pruebas_extra.randot" className="w-full p-2 border rounded" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Lang:</label>
                  <Field name="pruebas_extra.lang" className="w-full p-2 border rounded" />
                </div>
              </div>
            </div>

            {/* Visión de Color */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Visión de Color</label>
              <Field name="pruebas_extra.vision_color" className="w-full p-2 border rounded" />
            </div>

            {/* EVALUACION DE LA ACOMODACION */}
            <h4 className="text-lg font-bold mb-4">EVALUACION DE LA ACOMODACION</h4>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">A.A OD:</label>
                <Field name="acomodacion.aa_od" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">OI</label>
                <Field name="acomodacion.aa_oi" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">FAM: OD</label>
                <Field name="acomodacion.fan_od" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">OI</label>
                <Field name="acomodacion.fan_cpm" className="w-full p-2 border rounded" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">FAB</label>
                <Field name="acomodacion.aco_oi" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MEM: OD</label>
                <Field name="acomodacion.aco_cpm" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">OI</label>
                <Field name="acomodacion.acp_fab" className="w-full p-2 border rounded" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">ARN</label>
                <Field name="acomodacion_extra.mem_arn" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">ARP</label>
                <Field name="acomodacion_extra.mem_arp" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* EVALUACION DE LAS VERGENCIAS */}
            <h4 className="text-lg font-bold mb-4">EVALUACION DE LAS VERGENCIAS</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">BT/VL</label>
                <Field name="vergencia.v_vt_vl" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">BT/VP</label>
                <Field name="vergencia.v_bt_vp" className="w-full p-2 border rounded" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">BN/VL</label>
                <Field name="vergencia.v_bn_vl" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">BN/VP</label>
                <Field name="vergencia.v_bn_vp" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* RECETA FINAL */}
            <h5 className="text-lg font-bold mb-4">RECETA FINAL</h5>
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-center">RX</th>
                    <th className="border px-4 py-2">ESFERA</th>
                    <th className="border px-4 py-2">CILINDRO</th>
                    <th className="border px-4 py-2">EJE</th>
                    <th className="border px-4 py-2">P/BASE △</th>
                    <th className="border px-4 py-2">ADD</th>
                    <th className="border px-4 py-2">AGUDEZA VISUAL</th>
                  </tr>
                </thead>
                <tbody>
                  {['od', 'oi'].map((ojo) => (
                    <tr key={ojo}>
                      <td className="border px-4 py-2 text-center">Ojo {ojo === 'od' ? 'Derecho' : 'Izquierdo'}</td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.esfera_${ojo}_f`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.cilindro_${ojo}_f`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.eje_${ojo}_f`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.p_base_${ojo}_f`} className="w-full p-1 border rounded" placeholder="△" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.add_${ojo}_f`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`refraccion.agz_${ojo}_f`} className="w-full p-1 border rounded" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Lentes */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">TIPO DE LENTE</label>
                <Field name="lentes_contacto.lente_marca_1" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">PD</label>
                <Field name="lentes_contacto.lente_pd_1" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">DNP</label>
                <Field name="lentes_contacto.lente_dnp_1" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* Lente de Contacto */}
            <h5 className="text-lg font-bold mb-4">Lente de Contacto</h5>
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2">PARAMETROS</th>
                    <th className="border px-4 py-2 text-center">OJO DERECHO</th>
                    <th className="border px-4 py-2 text-center">OJO IZQUIERDO</th>
                  </tr>
                </thead>
                <tbody>
                  {['poder', 'cb', 'dia'].map((param) => (
                    <tr key={param}>
                      <td className="border px-4 py-2 text-center">{param.toUpperCase()}</td>
                      <td className="border px-4 py-2">
                        <Field name={`lentes_contacto.${param}_od`} className="w-full p-1 border rounded" />
                      </td>
                      <td className="border px-4 py-2">
                        <Field name={`lentes_contacto.${param}_oi`} className="w-full p-1 border rounded" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MARCA</label>
                <Field name="lentes_contacto.lente_marca" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">TIPO</label>
                <Field name="lentes_contacto.lente_tipo" className="w-full p-2 border rounded" />
              </div>
            </div>

            {/* CONDUCTA A SEGUIR */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">CONDUCTA A SEGUIR:</label>
              <Field
                as="textarea"
                name="conducta_seguir"
                className="w-full p-2 border rounded min-h-[100px]"
              />
            </div>

            {/* Fecha próxima cita */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de proxima cita</label>
              <Field
                name="fecha_proxima_consulta"
                type="date"
                className="w-full p-2 border rounded"
                required
              />
            </div>

            {/* Servicios */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Servicios Realizados</label>
                <Select
                  showSearch
                  placeholder="Seleccionar servicio"
                  options={[]}
                  className="w-full"
                  onChange={(value, option) => { }}
                />
                <div className="flex flex-wrap gap-2 mt-2">
                  {[
                    { value: 1, label: "label" }
                  ].map(servicio => (
                    <Tag
                      key={servicio.value}
                      closable
                      onClose={() => { }}
                      className="flex items-center"
                    >
                      {servicio.label}
                    </Tag>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Proximos Servicios</label>
                <Select
                  showSearch
                  placeholder="Seleccionar servicio"
                  options={[]}
                  className="w-full"
                  onChange={(value, option) => { }}
                />
                <div className="flex flex-wrap gap-2 mt-2">
                  {[
                    { value: 1, label: "label" }
                  ].map(servicio => (
                    <Tag
                      key={servicio.value}
                      closable
                      onClose={() => { }}
                      className="flex items-center"
                    >
                      {servicio.label}
                    </Tag>
                  ))}
                </div>
              </div>
            </div>

            {/* Botón de envío */}
            <Button
              type="primary"
              htmlType="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Guardar Consulta
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default OrtopticaVisionBinocular